let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f6gWw")).then(() => parcelRequire('cudJO'));